import React from "react";
import { Link } from "gatsby";
import LanguageSelector from "../LanguageSelector";

import { owner } from "../../data";

const Footer = ({ lingua }) => {
  /*
  const [consento, setConsento] = useState(true);

  useEffect(() => {
    setConsento(JSON.parse(localStorage.getItem("3dshirt_gdpr")) || false);
  }, []);

  const ok = () => {
    setConsento(true);
    localStorage.setItem("3dshirt_gdpr", true);
    localStorage.setItem("3dshirt_analytics", true);
  };
  const approf = () => {
    setConsento(true);
    localStorage.setItem("3dshirt_gdpr", true);
  };
  */

  return (

    <footer className="is-hidden-touch" style={{ background: "#b8b8b6" }}>
      <div className="section">
        <div className="container">
          <div className="columns">
            <div className="column">
              <span className="is-size-4">VIRTUAL<strong>TAILOR</strong></span>
            </div>
            <div className="column">
              <aside className="menu">
                <ul className="menu-list">
                  <li>
                    <Link
                      to="/"
                      className="level-item"
                      activeStyle={{ color: "#5d7e9d" }}
                    >
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/"
                      className="level-item"
                      activeStyle={{ color: "#5d7e9d" }}
                    >
                      {lingua.footer.contattaci}
                    </Link>
                  </li>
                </ul>
              </aside>
            </div>

            <div className="column">
              <aside className="menu">
                <ul className="menu-list">
                  <li>
                    <Link
                      to="/privacy-policy/"
                      className="level-item"
                      activeStyle={{ color: "#5d7e9d" }}
                    >
                      {lingua.footer.privacy}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/cookie-policy/"
                      className="level-item"
                      activeStyle={{ color: "#5d7e9d" }}
                    >
                      {lingua.footer.cookie}
                    </Link>
                  </li>
                  {/** 
                    <li>
                      <Link
                        to="/terms/"
                        className="level-item"
                        activeStyle={{ color: "#5d7e9d" }}
                      >
                        {lingua.footer.termini}
                      </Link>
                    </li>
                    */}
                  {/** 
                    <li>
                      <Link
                        to="/withdrawal/"
                        className="level-item"
                        activeStyle={{ color: "#5d7e9d" }}
                      >
                        {lingua.footer.recesso}
                      </Link>
                    </li>
                  */}
                </ul>
              </aside>
            </div>

            <div className="column is-narrow">
              <LanguageSelector />
            </div>
          </div>
        </div>
      </div>
      <div className="section p-4" style={{ background: "#5a5a58", color: "#fff" }}>
        <p className="is-size-7 has-text-centered has-text-bold">
          &copy; {new Date().getFullYear()} PIERLUCA BELLICOSO - Tutti i diritti riservati -{" "}
          {lingua.footer.partita} {owner.piva}
        </p>
      </div>
    </footer>

  );
};

export default Footer;
